import { BASE_URL } from '@apps/config';
import { useRouter } from 'next/router';

export type SEOLocalesProps = null;

/**
 * ===========================
 * MAIN
 * ===========================
 */
export const SEOLocaleList: React.FC = () => {
  const router = useRouter();
  const detailsId = router.query?.slug?.[2];
  const { locales } = router;

  // ======================= HOOKS

  // ======================= RENDER FUNCTIONS
  const renderLocaleAnchorTag = (locale: string) => {
    const currentUrl = `${BASE_URL}${locale === 'en' ? '' : `/${locale}`}${
      router?.asPath
    }`;
    let cleanedPath = currentUrl.split('?')[0]?.toLowerCase();
    // Handle old url
    if (detailsId) {
      const newUrl = currentUrl.split('?')[0]?.toLowerCase();
      const parts = newUrl.split('?')[0].split('/');
      parts.pop();
      cleanedPath = parts.join('/');
    }
    return (
      <a className="visuallyhidden" href={cleanedPath} key={locale}>
        {locale.toUpperCase()}
      </a>
    );
  };

  // ======================= VIEWS
  return locales?.map((loca) => {
    return renderLocaleAnchorTag(loca);
  });
};

/**
 * ===========================
 * EXPORTS
 * ===========================
 */
export default SEOLocaleList;
